import React, {PropsWithChildren} from 'react';
import {PaymentsEnvContext, type PaymentsEnv} from './PaymentsEnv';

function PaymentsEnvProvider({value, children}: PropsWithChildren<{value: PaymentsEnv}>) {
  return (
    <PaymentsEnvContext.Provider value={value}>{children}</PaymentsEnvContext.Provider>
  );
}

export {PaymentsEnvProvider};
